import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "hasLowCredits"];
import { Caption, Heading, LayoutSpaceVertical, Skeleton } from 'breeze-intelligence-kit';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const CreditTile = ({
  children,
  isLoading
}) => /*#__PURE__*/_jsx(LayoutSpaceVertical, {
  background: "background-color",
  borderRadius: "border-radius",
  gap: "space-xxs",
  padding: "space",
  children: /*#__PURE__*/_jsx(Skeleton, {
    blockSize: "2.625rem",
    inlineSize: "100%",
    isLoading: isLoading,
    variant: "light",
    children: children
  })
});
const CountHeading = styled(Heading).withConfig({
  displayName: "CreditTile__CountHeading",
  componentId: "sc-19opumf-0"
})(["small{font-size:0.875rem;}"]);
CreditTile.Count = _ref => {
  let {
      children,
      hasLowCredits
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CountHeading, Object.assign({
    color: hasLowCredits ? 'danger' : 'base',
    forwardedAs: "h4"
  }, rest, {
    children: children
  }));
};
CreditTile.Label = ({
  children
}) => /*#__PURE__*/_jsx(Caption, {
  as: "div",
  margin: "0",
  children: children
});
CreditTile.Reset = ({
  children
}) => /*#__PURE__*/_jsx(Caption, {
  as: "div",
  children: children
});